export const REFETCH_INTERVAL = 30000;
